<div [className]="validate && isValidated(value) ? 'invalid-input' : 'input'">
  <span class="input-name">{{name}}</span>
  <span *ngIf="required" class="required-red">*</span>
  <img *ngIf="withImage" src="../../../../assets/icons/Magnifier.svg" class="input-image" [ngStyle]="name && {'top': '30px'}" (click)="imageClicked.emit(value)">
  <input type="text" (blur)="onSaveModel()" inputPattern (focus)="onSaveState()"
    class="input-component" [(ngModel)]="value" [placeholder]="placeholder" [disabled]="!!disabled"
    mask="AAAA AAAA AAAA AAAA" onkeyup="this.value=this.value.replace(/[^\d\s|X]+/,'')" (keyup.enter)="onKeyEnterSaveModel()">
</div>
